<template>
  <div class="component_card">
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column tal_c">
          <div class="column upper" v-if="parseFloat(msg) > 0">
          </div>
          <div class="column upper" v-else>
            {{ $t("msg.failed") }}
          </div>
          <div class="column">
            <div v-if="msg">
              <p v-html="$t('msg.available_to_redeem')" v-if="parseFloat(msg) > 0"></p>
              <p v-html="$t('msg.' + msg)" v-else></p>
            </div>
            <p class="action_blocked_message" v-else>
              {{ $t('msg.redeem_not_allowed_today_1') }}</p>
          </div>
        </div>
        <div class="column" v-if="msg">
          <button class="btn_redeem" style="width:100%;" @click="resetStep()">{{ $t("msg.back") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from "vuex";

export default {
  props: ['error', 'dayEnabled'],
  created() {
    this.getMsg();

  },
  mounted() {

  },
  data: () => ({
    msg: '',
  }),
  components: {

  },
  methods: {
    resetStep() {
      this.$emit('resetStep');
    },

    getMsg() {
      let array = this.error.split(" ");
      let msgErro = '';
      array.shift();
      msgErro = array.join('_');

      this.msg = msgErro.toLowerCase();
    },


  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/redeem_steps/RedeemStep9.vue